<template>
  <div class="logistics-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="物流公司名称">
          <el-input v-model="filterForm.name" placeholder="请输入物流公司名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">物流公司列表</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
        <div class="header-right">
          <el-button type="success" icon="el-icon-plus" @click="addLogistics">新增物流公司</el-button>
        </div>
      </div>
      
      <el-table
        :data="logisticsList"
        border
        v-loading="tableLoading"
        style="width: 100%">
        <template slot="empty">
          <div class="empty-block">
            <p class="empty-text">{{ tableLoading ? '加载中...' : '暂无数据' }}</p>
          </div>
        </template>
        <el-table-column
          type="index"
          label="序号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="trackName"
          label="公司名称"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="trackCode"
          label="公司代码"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status === 1 ? '正常' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="200">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button size="mini" type="primary" @click="editLogistics(scope.row)">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <logistics-form
      :visible.sync="formVisible"
      :is-edit="isEdit"
      :logistics-data="currentLogistics"
      @success="handleFormSuccess"
    />
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'
import LogisticsForm from './LogisticsForm.vue'

export default {
  name: 'Logistics',
  components: {
    LogisticsForm
  },
  data() {
    return {
      filterForm: {
        name: '',
        status: ''
      },
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      logisticsList: [],
      formVisible: false,
      isEdit: false,
      currentLogistics: {}
    }
  },
  created() {
    this.fetchLogistics()
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hour = String(d.getHours()).padStart(2, '0');
      const minute = String(d.getMinutes()).padStart(2, '0');
      const second = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    async fetchLogistics() {
      this.tableLoading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          trackName: this.filterForm.name,
          status: this.filterForm.status || null
        }
        
        const res = await adminApi.getLogisticsListByPage(params)
        if (res.data && res.data.code === 200) {
          this.logisticsList = Array.isArray(res.data.data) ? res.data.data : []
          this.totalItems = res.data.count || 0
        } else {
          this.logisticsList = []
          this.totalItems = 0
          this.$message.error(res.data?.msg || '获取物流公司列表失败')
        }
      } catch (error) {
        console.error('获取物流公司列表错误:', error)
        this.logisticsList = []
        this.totalItems = 0
        this.$message.error(error.message || '获取物流公司列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.fetchLogistics()
    },
    resetFilter() {
      this.filterForm = {
        name: '',
        status: ''
      }
      this.handleFilter()
    },
    handleSizeChange() {
      this.fetchLogistics()
    },
    handleCurrentChange() {
      this.fetchLogistics()
    },
    getStatusType(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status] || 'info'
    },
    addLogistics() {
      this.isEdit = false
      this.currentLogistics = {}
      this.formVisible = true
    },
    editLogistics(row) {
      this.isEdit = true
      this.currentLogistics = { ...row }
      this.formVisible = true
    },
    deleteLogistics(row) {
      this.$confirm(`确定要删除物流公司 ${row.trackName} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await adminApi.deleteLogistics(row.id)
          if (res.data && res.data.code === 200) {
            this.$message.success(res.data.msg || `删除成功`)
            this.fetchLogistics()
          } else {
            this.$message.error(res.data?.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除物流公司错误:', error)
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {
        // 用户取消操作
      })
    },
    handleFormSuccess() {
      this.fetchLogistics()
    }
  }
}
</script>

<style scoped>
.logistics-container {
  padding: 20px 0;
}

.filter-card {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.count {
  color: #909399;
  font-size: 14px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.operation-buttons {
  display: flex;
  gap: 8px;
}

.empty-block {
  padding: 30px 0;
  text-align: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.empty-text {
  color: #909399;
  font-size: 14px;
  margin: 0;
}
</style> 